import { useForm, type SubmitHandler } from "react-hook-form"
import Typography from '@mui/material/Typography'

import useFormLocalStorage from "@/hooks/use-form-local-storage"
import { APP_VERSION } from "@/constants/general"
import Form from "@/components/forms/reusables/form"
import useFormStates from "@/hooks/use-form-states"
import RHFRichText from "@/components/form-fields/rhf-rich-text"
import type {
    CollectionCalendarInfo,
    CollectionCalendarInfoFormInput,
} from "@/types"
import {
    useCreateCollectionCalendarInfo,
    useUpdateCollectionCalendarInfo,
} from "@/hooks/api/use-collection-calendar-info"

const CollectionCalendarInfoForm = ({
    collectionCalendarInfo,
    closeCallback,
} : {
    collectionCalendarInfo?: CollectionCalendarInfo,
    closeCallback?: () => void,
}) => {

    const formDataId = `collectionCalendarInfoForm-${collectionCalendarInfo?.id}-v${APP_VERSION}`

    const initialValues = {
        description: collectionCalendarInfo ? collectionCalendarInfo.description : '',
    }
    
    const {
        control,
        handleSubmit,
        formState: { isDirty },
        reset,
        // watch,
    } = useForm({
        defaultValues: { ...initialValues },
    })

    const [isLoadedFromLocalStorage, handleFormReset] = useFormLocalStorage({
        control,
        formDataId,
        reset,
        initialValues
    })

    const {
        resetWithVersion,
        requestInProgress,
        setRequestInProgress,
    } = useFormStates(handleFormReset)

    const mutationCreate = useCreateCollectionCalendarInfo({
        setRequestInProgress,
        formDataId,
        onSuccessCallback: closeCallback,
    })

    const mutationUpdate = useUpdateCollectionCalendarInfo(
        collectionCalendarInfo?.id,
        {
            setRequestInProgress,
            formDataId,
            onSuccessCallback: closeCallback,
        },
    )

    const onSubmit: SubmitHandler<CollectionCalendarInfoFormInput> = data => {
        setRequestInProgress(true)
        if (collectionCalendarInfo?.id) {
            mutationUpdate.mutate(data)
        } else {
            mutationCreate.mutate(data)
        }
    }

    // const description = watch('description')

    return (
        <Form
            onSubmit={handleSubmit(onSubmit)}
            heading={collectionCalendarInfo ? 'Upravit obsah' : 'Vytvořit sekci'}
            closeCallback={closeCallback}
            isLoadedFromLocalStorage={isLoadedFromLocalStorage}
            isDirty={isDirty}
            resetWithVersion={resetWithVersion}
            requestInProgress={requestInProgress}
            buttonText={collectionCalendarInfo ? 'Upravit' : 'Vytvořit sekci'}
            //disableSave={!description}
        >
            <RHFRichText
                name="description"
                control={control}
                label="Obsah"
                multipleRows
            />
            {!collectionCalendarInfo &&
                <Typography variant="body1" component="p" gutterBottom>
                    Soubory ke stažení budete moct přidat po vytvoření.
                </Typography>
            }
        </Form>
    )
}

export default CollectionCalendarInfoForm
